module.exports = "/packs/media/images/DebtFree-2e99210444c0da79811c0b1027ab82d9.png";